module.exports = __webpack_public_path__ + "static/media/bus-school.efb7cad3.svg";